import React, { useEffect, useRef, useState } from 'react'
import arrow_down from '../../../assets/svg/arrow-down.svg'
import arrow_up from '../../../assets/svg/arrow-up.svg'
import DropdownItem from './DropdownItem'

type Props = {
    children: JSX.Element,
    dropdownData: any,
    dropdownStyle?: string,
    containerStyle?: string,
    arrowIcon?: boolean,
    arrowStyle?: string,
    selector?: boolean,
    dropdown: boolean,
    objectType?: string,
    setDropdown: (data?: any) => void,
    handleSelect?: (data?: any) => void
}

const Dropdown = (props: Props) => {
    const dropdownRef = useRef<HTMLDivElement>(null);

    const handleClickOutside = (e: MouseEvent) => {
        if(dropdownRef.current && !dropdownRef.current.contains(e.target as Node)){
            props.setDropdown(false);
            
        }
    }

    useEffect(()=>{
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const contentType = Array.isArray(props.dropdownData)

    const propArrowIcon = props.arrowIcon !== undefined ? props.arrowIcon : true;

    const actionFunction = (item, handleSelect) => {
        item.value ? handleSelect(item.value) : handleSelect(item.title)
        props.setDropdown && props.setDropdown(false)
    }

    const componentContent = (

        !contentType || props.objectType === 'custom'
            ? props.dropdownData

            : props.dropdownData.map((item, i) => (
                <DropdownItem
                    key={i}
                    title={item.title ? item.title : item}
                    icon={item.icon}
                    iconStyle="w-5 h-5"
                    link={item.link}
                    style={`${item.style} my-1`}
                    fontStyle='text-sm'
                    handleClick={props.selector ? () => actionFunction(item, props.handleSelect) : item.action}
                    toggler={props.setDropdown}
                />
            ))
    )


    return (
      <div ref={dropdownRef} className="relative w-full">
        <div
          className={`${props.containerStyle} flex gap-3 justify-evenly items-center relative cursor-pointers`}
          onClick={
            propArrowIcon
              ? () => props.setDropdown((prevState) => !prevState)
              : () => {}
          }
        >
          {props.children}
          {propArrowIcon && (
            <img
              src={props.dropdown ? arrow_up : arrow_down}
              alt="arrow_down"
              className={`${props.arrowStyle}`}
            />
          )}
        </div>
        {props.dropdown && (
          <div
            className={`${props.dropdownStyle} ${
              contentType ? "px-1" : "p-5"
            } absolute z-20 bg-white rounded-md w-fit shadow-[0_8px_30px_rgb(0,0,0,0.12)] animate-slide_down`}
          >
            <div
              className={`rounded-md overflow-hidden w-fit ${
                contentType ? "min-w-[150px]" : "min-w-[250px]"
              }`}
            >
              {componentContent}
            </div>
          </div>
        )}
      </div>
    );
}

export default Dropdown;